import useSession from '@/hooks/use-session';

// Modernizing rewrites how a live playbook authenticates, so the tooling stays with the one person
// running the migration.
export const MODERNIZE_EMAIL = 'elliott@onefootprint.com';
const useCanModernize = () => {
  return useSession().data.user?.email === MODERNIZE_EMAIL;
};
export default useCanModernize;